<template>
  <div>
    <breadcrumbs></breadcrumbs>
    <div class="datd-abc">
      <div class="ind-title lh50 f16">
        <!-- <i class="el-icon-loading"></i> -->
        库存详情
      </div>
    </div>

    <div class="a7">
      <div class="a1">
        <div>
          <img
            class="a1-img"
            src="../../assets/images/yhx1.png"
            alt=""
            srcset=""
          />
        </div>

        <div class="a4">
          <div class="a2">{{ arr.stockCount }}</div>
          <div class="a3">当前库存总数</div>
        </div>
      </div>

      <div class="a1">
        <div>
          <img
            class="a1-img"
            src="../../assets/images/yhx2.png"
            alt=""
            srcset=""
          />
        </div>

        <div class="a4">
          <div class="a2">{{ arr.backStopRoadCount }}</div>
          <div class="a3">在途库存总数</div>
        </div>
      </div>

      <div class="a1">
        <div>
          <img
            class="a1-img"
            src="../../assets/images/yhx2.png"
            alt=""
            srcset=""
          />
        </div>

        <div class="a4">
          <div class="a2">{{ arr.defStockCount }}</div>
          <div class="a3">次品数</div>
        </div>
      </div>

      <div class="a1">
        <div>
          <img
            class="a1-img"
            src="../../assets/images/yhx2.png"
            alt=""
            srcset=""
          />
        </div>

        <div class="a4">
          <div class="a2">{{ arr.totalStockCount }}</div>
          <div class="a3">累计库总数</div>
        </div>
      </div>
    </div>
    <div class="con-let"></div>

    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column label="序号" prop="index" type="index">
      </el-table-column>

      <el-table-column label="品牌" prop="brandName"> </el-table-column>

      <el-table-column label="累计库存数" prop="totalStockCount">
      </el-table-column>

      <el-table-column label="已出库存数" prop="toPoCount"> </el-table-column>

      <el-table-column label="次品数" prop="defStockCount"> </el-table-column>

      <el-table-column label="在途库存数" prop="roadnum"> </el-table-column>

      <el-table-column label="当前库存数" prop="stockCount"> </el-table-column>
    </el-table>

    <el-pagination
      class="mgt-10 pd-0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searlist.curPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="searlist.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    >
    </el-pagination>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      searlist: {
        curPage: 1,
        pageSize: 10,
      },
      arr: "",
      totalCount: 0,
      id: this.$route.query.id,
      tableData: [],
      shanghai: "",
      beijing: "",
      searchForm: {
        name: "",
        region: "",
      },
    };
  },

  created() {
    this.getOpHouseStockDetailTotal();

    this.getOperateHouseStockList(
      this.searlist.curPage,
      this.searlist.pageSize
    );
  },

  methods: {
    handleSizeChange(v) {
      this.searlist.pageSize = v;
      this.getOperateHouseStockList(this.searlist.curPage, v);
    },
    handleCurrentChange(v) {
      this.searlist.curPage = v;

      this.getOperateHouseStockList(v, this.searlist.pageSize);
    },

    getOperateHouseStockList(curr, pagesize) {
      this.$api.activitymsg
        .getOperateHouseStockList({
          houseId: this.id,
          current: curr,
          size: pagesize,
        })
        .then((e) => {
          this.tableData = e.data;
          this.totalCount = e.totalCount;
        });
    },

    getOpHouseStockDetailTotal() {
      this.$api.activitymsg
        .getOpHouseStockDetailTotal({
          houseId: this.id,
        })
        .then((e) => {
          this.arr = e.data;
        });
    },
  },
};
</script>

<style scoped>
.con-let {
  height: 50px;
}

.a7 {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.a4 {
  margin-left: 20px;
}

.a3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;

  color: var(--text-main);
  opacity: 1;
}

.a2 {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: var(--text-main);
  opacity: 1;
}

.a1-img {
  width: 100px;
  height: 100px;
}
.a1 {
  width: 260px;
  height: 127px;
  opacity: 1;
  border-radius: 10px;
  border: solid 1px var(--table-border);
  display: flex;
  align-items: center;
  padding: 0 20px;
}
</style>
